import { Container } from "@mantine/core"
import { useState } from "react"

import {
  AxesFeatureLabelsMetadata,
  LabelsExplorerResponses,
} from "@costory/types/endpoints/labelsExplorer"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { Step2Deduplication } from "@costory/front/pages/LabelsExplorer/components/step2Deduplication"
import { LabelsExplorerValues } from "@costory/front/pages/LabelsExplorer/labelsExplorerValues"
import {
  useAxesFeatureLabelsQuery,
  useLabelsExplorerStatsQuery,
} from "@costory/front/queries/labelsExplorer"

const _LabelsExplorerPage = ({
  labels,
  axesFeatureLabels,
}: {
  labels: LabelsExplorerResponses.LabelsStatsFullBilling[]
  axesFeatureLabels: {
    transformations: AxesFeatureLabelsMetadata
  }
}) => {
  const [ingestMode, setIngestMode] = useState(false)

  return (
    <Container fluid h="95%" size="100%">
      {ingestMode ? (
        <Step2Deduplication allLabels={labels} setIngestMode={setIngestMode} />
      ) : (
        <LabelsExplorerValues
          labels={labels}
          ingestMode={ingestMode}
          setIngestMode={setIngestMode}
          axesFeatureLabels={axesFeatureLabels}
        />
      )}
    </Container>
  )
}
export const LabelsExplorerPage = () => {
  const query = useLabelsExplorerStatsQuery()
  const axesFeatureLabelsQuery = useAxesFeatureLabelsQuery()

  return (
    <Container fluid h="95%" size="100%">
      <QueryWrapper query={query} allowEmptyArray>
        {({ data }) => (
          <QueryWrapper query={axesFeatureLabelsQuery} allowEmptyArray>
            {({ data: axesFeatureLabels }) => (
              <_LabelsExplorerPage
                labels={data}
                axesFeatureLabels={axesFeatureLabels}
              />
            )}
          </QueryWrapper>
        )}
      </QueryWrapper>
    </Container>
  )
}
